<template>
  <div style="padding: 10px">
    <x-table
      ref="list"
      listApi="biz.warehouse.arranged.info.list"
      paginationLayout="total, sizes, prev, next, jumper"
      actionFixed="right"
      emptyLabel="暂无补货计划记录信息"
      :fieldList="fieldList"
      :actionList="actionList"
      :paramList="paramList"
      :btnList="btnList"
      :defaultParams="defaultParams"
      :actionWidth="180"
    >
      <template slot="row-info" slot-scope="scope">
        <div style="font-weight: bolder">
          {{ scope.row.arrangedName }}
        </div>
        <div>计划编号：{{ scope.row.guid }}</div>
        <div>
          创建时间：{{ new Date(scope.row.createTime).format("yyyy-MM-dd hh:mm:ss") }}
        </div>
      </template>
    </x-table>
  </div>
</template>

<script>
import arrangedDetailPage from "./__arranged_detail.vue";
import arrangedCreatePage from "./__arranged_create.vue";

export default {
  props: {
    tabName: {
      type: String,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultParams() {
      return this.pageQuery;
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  methods: {
    refresh() {
      if (this.$refs.list) {
        this.$refs.list.refresh();
      }
      this.$emit("call-event", "refresh");
    },
  },
  data() {
    return {
      paramList: [
        {
          label: "采购计划名称模糊查询",
          field: ["arrangedNameLike"],
          styleValue: "width: 300px",
        },
      ],
      fieldList: [
        {
          label: "记录信息",
          minWidth: "280",
          slot: "info",
        },
      ],
      actionList: [
        {
          label: "详情",
          linkType: "primary",
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: "补货计划记录详情",
              refresh: this.refresh,
              component: arrangedDetailPage,
              params: {
                guid: row.guid,
                storeGuid: row.storeGuid,
              },
            });
          },
        },
        {
          label: "编辑",
          linkType: "primary",
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: "编辑补货计划信息",
              refresh: this.refresh,
              component: arrangedCreatePage,
              params: {
                guid: row.guid,
                storehouseGuid: row.storehouseGuid,
              },
            });
          },
        },
        {
          label: "删除",
          linkType: "danger",
          click: (row, tag, refresh) => {
            this.$confirm("确认删除补货计划？", "警告", {
              type: "error",
            }).then(() => {
              this.cancelLoading = true;
              this.requestApi(
                "biz.warehouse.arranged.info.delete",
                {
                  guid: row.guid,
                  storeGuid: row.storeGuid,
                },
                {
                  showError: true,
                }
              ).then(() => {
                this.refresh();
              });
            });
          },
        },
      ],
      btnList: [
        {
          label: "创建补货计划",
          type: "primary",
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: "新增补货计划",
              refresh,
              component: arrangedCreatePage,
              params: this.defaultParams,
            });
          },
        },
      ],
    };
  },
};
</script>
